import React from 'react';
import './GbixDisplay.css';

/**
 * GbixDisplay Component
 * 
 * Displays a half-transparent GBIX item image in the right bottom part of the map.
 * The image has a transparent background and is positioned absolutely.
 */
const GbixDisplay = ({ gbixItem }) => {
  if (!gbixItem) {
    return null;
  }

  return (
    <div className="gbix-display">
      <img
        src={gbixItem.imagePath}
        alt={gbixItem.name}
        className="gbix-image"
        onError={(e) => {
          // Fallback if image doesn't exist - hide the element
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
};

export default GbixDisplay;

